import React from 'react';
import { View, Text } from 'react-native';
import DocketItemStyles from '../DocketItem.styles';
import { RUSH_TAG } from '../../../common/constants';

export interface Props {
  tags?: string[];
  rushedAt?: number;
}

const DocketTitleBar: React.FC<Props> = ({ tags = [], rushedAt }) => {
  const styles = DocketItemStyles();

  if (!tags.length && !rushedAt) return null;

  const displayTags = [...(rushedAt ? [RUSH_TAG] : []), ...tags];

  return (
    <View testID="docket-title-bar" style={styles.tagsContainer}>
      {displayTags.map(tag => {
        const isRush = tag === RUSH_TAG;
        return (
          <View
            key={tag}
            style={[styles.tagBadge, isRush && styles.rushTagBadge]}
          >
            <Text style={[styles.tagLabel, isRush && styles.rushTagLabel]}>
              {tag}
            </Text>
          </View>
        );
      })}
    </View>
  );
};

export default React.memo(DocketTitleBar);
